import { render, staticRenderFns } from "./Escalations.vue?vue&type=template&id=4bd5e2a0"
import script from "./Escalations.vue?vue&type=script&lang=js"
export * from "./Escalations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports